import { DEFAULT_LANGUAGE, SUPPORTED_LANGUAGES, SupportedLanguages } from './constants';

// Only EN: the default stands in for a flag we could not read, and English is the language every
// fallback resolves to. DE is opened by the flag like any other language.
export const BASE_AVAILABLE_LANGUAGES: SupportedLanguages[] = [SupportedLanguages.EN];

export function resolveAvailableLanguages(value: unknown): SupportedLanguages[] {
  if (!Array.isArray(value)) {
    return [...BASE_AVAILABLE_LANGUAGES];
  }

  const requested = value.map((code) => (typeof code === 'string' ? code.toUpperCase() : ''));

  // Filtered, never parsed into new state: a code we ship no bundle for cannot survive, so no
  // targeting rule can select a language the client is unable to render.
  const resolved = SUPPORTED_LANGUAGES.filter((language) => requested.includes(language));

  if (!resolved.length) {
    return [...BASE_AVAILABLE_LANGUAGES];
  }

  return SUPPORTED_LANGUAGES.filter((language) => language === DEFAULT_LANGUAGE || resolved.includes(language));
}

let availableLanguages: SupportedLanguages[] = BASE_AVAILABLE_LANGUAGES;

export function setAvailableLanguages(languages: SupportedLanguages[]): void {
  availableLanguages = languages.length ? languages : BASE_AVAILABLE_LANGUAGES;
}

export function getAvailableLanguages(): SupportedLanguages[] {
  return availableLanguages;
}

export function isAvailableLanguage(value?: unknown): value is SupportedLanguages {
  return availableLanguages.includes(value as SupportedLanguages);
}
